<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm04"><a id="page_v"></a><strong>FOUR BLONDES</strong></h1>
<p class="authorcenter"><strong>CANDACE BUSHNELL</strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04.vue?b78b3422